import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { Layout } from 'antd';
import PageHeader from '@/components/PageHeader';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useResponsive } from '@/contexts/ResponsiveContext';

const PageContentContext = createContext();

function PageContent ({ children }) {
  const [title, setTitle] = useState();
  const { isMobile } = useResponsive();
  const [breadcrumbCustomMap, setBreadcrumbCustomMap] = useState({});
  const [disabledBreadCrumb, setDisabledBreadCrumb] = useState([]);

  const addBreadcrumbCustomMap = useCallback((key, value) => {
    if (!breadcrumbCustomMap[key]) {
      breadcrumbCustomMap[key] = value;
      setBreadcrumbCustomMap(Object.assign({}, breadcrumbCustomMap));
    }
  }, [breadcrumbCustomMap]);

  return (
    <PageContentContext.Provider value={{
      setBreadcrumbCustomMap,
      breadcrumbCustomMap,
      addBreadcrumbCustomMap,
      setTitle,
      setDisabledBreadCrumb
    }}>
      <Layout>
        <Layout.Content className={'m-1 lg:m-5'}>
          <PageHeader title={title} className={classNames('mb-3 lg:mb-5', { 'truncate': isMobile })}
            customMap={breadcrumbCustomMap} disabledBreadCrumb={disabledBreadCrumb}/>
          {children}
        </Layout.Content>
      </Layout>
    </PageContentContext.Provider>
  );
}

function usePageContent (options = {}) {
  const context = useContext(PageContentContext);
  if (context === undefined) {
    throw new Error('usePageContent must be used within a PageContentProvider');
  }
  const { title } = options;
  const {
    setTitle, setBreadcrumbCustomMap, breadcrumbCustomMap, addBreadcrumbCustomMap, setDisabledBreadCrumb
  } = context;

  useEffect(() => {
    if (title)
      setTitle(title);
    return () => setTitle('');
  }, [setTitle, title]);

  return {
    setDisabledBreadCrumb,
    breadcrumbCustomMap,
    setTitle,
    setBreadcrumbCustomMap,
    addBreadcrumbCustomMap
  };
}

PageContent.propTypes = {
  children: PropTypes.any
};

export { PageContent, usePageContent };
